export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--ban-circle.2be31569.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};